export const dataLibD = [{
  word: 'dan',
  partOfSpeech: 'N',
  definition: ['tooth'],
  egSentenceKw: 'Yo waché dan\'y paski i té ka fè\'y mal.',
  egSentenceEn: 'They extracted his tooth because it was hurting him.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dent]',
  dialect: '🇱🇨',
  variant: [null],
},
{
  word: 'djòl',
  partOfSpeech: 'N',
  definition: ['mouth or snout of an animal'],
  egSentenceKw: 'I bay bouwik-la an koul wòch asou djòl li.',
  egSentenceEn: 'He hit the donkey on the mouth with a stone.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. gueule]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dwèt',
  partOfSpeech: 'ADJ',
  definition: ['right'],
  egSentenceKw: 'I soud an zòwèy dwèt li.',
  egSentenceEn: 'He is deaf in his right ear.',
  synonym: [null],
  antonym: ['gòch', 'kochi'],
  etymology: '[< Fr. droit]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dèyè',
  partOfSpeech: 'PREP',
  definition: ['behind'],
  egSentenceKw: 'Yo mété sak-la dèyè kay-la.',
  egSentenceEn: 'They put the bag behind the house.',
  synonym: [null],
  antonym: ['douvan'],
  etymology: '[< Fr. derrière]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'douvan',
  partOfSpeech: 'PREP',
  definition: ['in front of'],
  egSentenceKw: 'Tifi-a doubout douvan mwen.',
  egSentenceEn: 'The girl stood in front of me.',
  synonym: [null],
  antonym: ['dèyè'],
  etymology: '[< Fr. devant]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dé',
  partOfSpeech: 'ADJ',
  definition: ['some', 'a few'],
  egSentenceKw: 'La ni dé koté ki ni pinèz.',
  egSentenceEn: 'There are some places that have bedbugs.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. des]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dòla',
  partOfSpeech: 'N',
  definition: ['dollar'],
  egSentenceKw: 'Konmen dòla ou ni?',
  egSentenceEn: 'How many dollars do you have?',
  synonym: ['goud'],
  antonym: [null],
  etymology: '[< Fr. dollar]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'djè',
  partOfSpeech: 'ADV',
  definition: ['hardly any', 'scarcely any'],
  egSentenceKw: 'Nou pa té sa jwé bol-la paski la pa té ni djè moun.',
  egSentenceEn: 'We couldn\'t play ball because there were hardly any people.',
  synonym: [null],
  antonym: ['an chay'],
  etymology: '[< Fr. guère]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'diskasyon',
  partOfSpeech: 'N',
  definition: ['discussion'],
  egSentenceKw: 'Diskasyon sala pwen an chay tan mé i té entéwésan.',
  egSentenceEn: 'This discussion took a lot of time but it was interesting.',
  synonym: ['kozé'],
  antonym: [null],
  etymology: '[< Eng. discussion]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'djal',
  partOfSpeech: 'N',
  definition: ['chick', 'attractive girl or woman'],
  egSentenceKw: 'Tifi sala sé on bèl djal.',
  egSentenceEn: 'This girl is a nice chick.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. girl]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'djip',
  partOfSpeech: 'N',
  definition: ['Jeep', 'four-wheel drive vehicle'],
  egSentenceKw: 'Yo wivé abò on djip.',
  egSentenceEn: 'They arrived in a Jeep.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. Jeep]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'djòb',
  partOfSpeech: 'N',
  definition: ['job', 'work'],
  egSentenceKw: 'I pèd djòb li tou.',
  egSentenceEn: 'He lost his job too.',
  synonym: ['twavay'],
  antonym: [null],
  etymology: '[< Eng. job]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'djòs',
  partOfSpeech: 'ADV',
  definition: ['just'],
  egSentenceKw: 'Ti manmay-la pa malad; i djòs mové.',
  egSentenceEn: 'The child isn\'t sick; he\'s just bad.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. just]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'drayv',
  partOfSpeech: 'V',
  definition: ['to drive'],
  egSentenceKw: 'Sa ki ka drayv motoka-a?',
  egSentenceEn: 'Who is driving the car?',
  synonym: ['kondwi'],
  antonym: [null],
  etymology: '[< Eng. drive]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'denmen',
  partOfSpeech: 'ADV',
  definition: ['tomorrow'],
  egSentenceKw: 'Denmen nou kay mouté an jaden.',
  egSentenceEn: 'Tomorrow we\'ll go to the garden.',
  synonym: [null],
  antonym: ['yè'],
  etymology: '[< Fr. demain]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dakò',
  partOfSpeech: 'INTERJ',
  definition: ['okay', 'agreed'],
  egSentenceKw: 'Dakò, sé sa nou kay fè.',
  egSentenceEn: 'Agreed, that\'s what we\'ll do.',
  synonym: ['aji'],
  antonym: [null],
  etymology: '[< Fr. d\'accord]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dakò',
  partOfSpeech: 'INTERJ',
  definition: ['to agree'],
  egSentenceKw: 'Mwen dakò épi tout sa ou di-a.',
  egSentenceEn: 'I agree with everything you said.',
  synonym: ['aji'],
  antonym: [null],
  etymology: '[< Fr. d\'accord]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dapwé',
  partOfSpeech: 'PREP',
  definition: ['according to (one\'s own understanding or opinion)'],
  egSentenceKw: 'Dapwé\'w mwen té ka pasé an ti chimen.',
  egSentenceEn: 'You thought I was passing on the little road.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. d\'après]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dépi',
  partOfSpeech: 'CONJ',
  definition: ['since'],
  egSentenceKw: 'Lòt mwa kay fè dé lanné dépi mwen mayé.',
  egSentenceEn: 'Next month will be two years since I got married.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. depuis]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dépi',
  partOfSpeech: 'CONJ',
  definition: ['whenever', 'as soon as'],
  egSentenceKw: 'Dépi tibway sala wè manjé i ka dépalé.',
  egSentenceEn: 'Whenever this boy sees food he talks nonsense.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. depuis]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dépi',
  partOfSpeech: 'CONJ',
  definition: ['if', 'since', 'as long as'],
  egSentenceKw: 'Dépi ou blan ou sipozé ni lajan.',
  egSentenceEn: 'If you are white you are expected to have money.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. depuis]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dépi',
  partOfSpeech: 'PREP',
  definition: ['from'],
  egSentenceKw: 'I té ni gwo dlo dépi Bèson pou wivé Kastwi.',
  egSentenceEn: 'There was a flood from Bexon to Castries.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. depuis]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dépi',
  partOfSpeech: 'PREP',
  definition: ['since', 'ever since'],
  egSentenceKw: 'Dépi jou sala mangous pa janmen manjé mango lonng ankò.',
  egSentenceEn: 'Ever since that day mongoose never eat mango lonng any more.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. depuis]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dèwò',
  partOfSpeech: 'PREP',
  definition: ['outside (of)'],
  egSentenceKw: 'Yo té dèwò kay-la lè yo tann ti manmay-la ka hélé.',
  egSentenceEn: 'They were outside the house when they heard the child crying.',
  synonym: [null],
  antonym: ['adan', 'an', 'andidan'],
  etymology: '[< Fr. dehors]',
  dialect: '🇱🇨',
  variant: ['dòwò'],
}, {
  word: 'di',
  partOfSpeech: 'V',
  definition: ['to tell'],
  egSentenceKw: 'I di mwen i kay vini pli ta.',
  egSentenceEn: 'He told me he would come later.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'di',
  partOfSpeech: 'PREP',
  definition: ['of'],
  egSentenceKw: 'I fè sa a laj di kenz an.',
  egSentenceEn: 'He did that at the age of 15 years.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. de]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'di',
  partOfSpeech: 'V',
  definition: ['to say'],
  egSentenceKw: 'Pa di sa pa vwé!',
  egSentenceEn: 'Don\'t say that isn\'t true!',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'di',
  partOfSpeech: 'ADJ',
  definition: ['hard'],
  egSentenceKw: 'Ki mannyè tèt ou di kon sa?',
  egSentenceEn: 'Why are you so stubborn?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'douvan',
  partOfSpeech: 'PREP',
  definition: ['before', 'in the sight of', 'with respect to'],
  egSentenceKw: 'Nou ni on bon doubout douvan Bondyé.',
  egSentenceEn: 'We have a good standing before God.',
  synonym: [null],
  antonym: ['dèyè'],
  etymology: '[< Fr. devant]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dèyè',
  partOfSpeech: 'PREP',
  definition: ['after', 'in pursuit of'],
  egSentenceKw: 'I alé dèyè Tijan.',
  egSentenceEn: 'He went in pursuit of Tijan.',
  synonym: [null],
  antonym: ['douvan'],
  etymology: '[< Fr. derrière]',
  dialect: '🇱🇨',
  variant: [null],
},
];
